import React, { useState } from 'react';
import { IconButton } from 'components/common';
import { useNavigate } from 'react-router-dom';
import { FaArrowLeft, FaUserPlus } from 'react-icons/fa';
import RoleForm from './RoleForm';

const RoleHeader = () => {
  const [showRoleForm, setShowRoleForm] = useState(false);
  const [title, setTitle] = useState('');
  const navigate = useNavigate();

  const handleNewRole = () => {
    setTitle('New Role');
    setShowRoleForm(true);
  };

  return (
    <>
      <div className="tw-bg-white tw-rounded-2xl tw-border tw-border-gray-200 tw-shadow-sm tw-mb-3">
        <div className="tw-flex tw-items-center tw-justify-between tw-px-4 tw-py-3">
          <IconButton icon={<FaArrowLeft size={12} />} onClick={() => navigate(-1)} title="Go back" />
          <div className="tw-flex tw-items-center tw-gap-1">
            <IconButton icon={<FaUserPlus size={12} />} onClick={handleNewRole} title="New role">
              <span className="tw-hidden xl:tw-inline">New Role</span>
            </IconButton>
          </div>
        </div>
      </div>

      <RoleForm
        showModal={showRoleForm}
        setshowModal={setShowRoleForm}
        title={title}
        role={null}
      />
    </>
  );
};

export default RoleHeader;

